import { render, staticRenderFns } from "./AppStatisticsClicks.vue?vue&type=template&id=5a54e73c&scoped=true"
import script from "./AppStatisticsClicks.vue?vue&type=script&lang=js"
export * from "./AppStatisticsClicks.vue?vue&type=script&lang=js"
import style0 from "./AppStatisticsClicks.vue?vue&type=style&index=0&id=5a54e73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a54e73c",
  null
  
)

export default component.exports